import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireDatabase, FirebaseListObservable } from "angularfire2/database-deprecated";
import { ActivatedRoute, Router } from "@angular/router";
import { concat } from 'rxjs/operator/concat';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
    selector: 'app-userlist',
    templateUrl: './userlist.component.html',
    styleUrls: ['./userlist.component.scss']
})
export class UserlistComponent implements OnInit, OnDestroy {

    rows: any[];
    loadingIndicator = true;
    reorderable = true;
    queryString: any;
    length: any;
    private sub: any;
    post: any;

    constructor(private http: HttpClient, private route: ActivatedRoute,
        private afs: AngularFirestore,
        private router: Router) {

    }

    ngOnInit() {
        this.route.queryParamMap.subscribe(params => {
            this.queryString = this.route.snapshot.queryParams['name'];
        });
        console.log(this.queryString)
        this.afs.collection('complaints').doc(this.queryString).ref.get().then(res => {

            this.post = res.data();
            this.post.text = (this.post.text).replace(/href="/g, 'href="https://big-advice.firebaseapp.com/');

        });
        this.sub = this.afs.collection('complaints').doc(this.queryString).collection('users').valueChanges().subscribe(data => {
            this.rows = data;
            this.length = data.length;
            this.loadingIndicator = false;
        })

    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/userlist/userlist.component.ts